module.exports = __webpack_public_path__ + "static/media/levels_4_2.211f3cc9.svg";